<template>
    <div class="addressBook">
        <van-loading
            class="pageLogin"
            v-if="isloading"
            type="spinner"
            color="#1989fa"
        ></van-loading>
        <van-nav-bar
            title="通讯录"
        >
            <van-icon name="plus" slot="right" @click="addUser"></van-icon>
        </van-nav-bar>
        <div class="noData" v-if="groupData.length<1 && topContactsData.length<1"></div>
        <section v-else>
            <van-search v-model="value" placeholder="请输入搜索信息"></van-search>
            <div class="list van-pull-refresh">
                <dl v-if="groupData.length > 0">
                    <dt>常用群组</dt>
                    <dd>
                        <template v-for="(item,index) in groupData">
                            <div class="van-cell " :key="index" @click="groupChat(item)">
                                <img class="van_left" src="@/assets/images/addressBook/icon_group_1@2x.png" alt="头像">
                                <div class="van_left info">
                                    <p>{{ item.teamName }}</p>
                                    <span>{{ item.memberNumber }}人</span>
                                </div>
                            </div>
                        </template>
                    </dd>
                </dl>
                <dl v-if="topContactsData.length > 0">
                    <dt>常用联系人</dt>
                    <dd>
                        <van-index-bar :index-list="indexList" :sticky="false">
                            <template v-for="(item, index) in topContactsData">
                                <van-index-anchor :index="item.Initial" :key="index"></van-index-anchor>
                                <template v-for="(k, i) in item.data">
                                    <van-cell :key="i" @click="openContactInfo(k.friend_id)">
                                        <img class="van_left" src="@/assets/images/addressBook/goodFriend.png" alt="头像">
                                        <div class="van_left info">
                                            <p>{{ k.friend_name }}</p>
                                            <span>{{ k.friend_org_name }}</span>
                                        </div>
                                    </van-cell>
                                </template>
                            </template>
                        </van-index-bar>
                    </dd>
                </dl>
            </div>
        </section>
        <van-action-sheet
            v-model="show"
            :actions="actions"
            @select="onSelect"
            cancel-text="取消"
        ></van-action-sheet>
    </div>
</template>

<script>

export default {
    // 通讯录
    name: 'address-book',
    components: {},
    props: {},
    data() {
        return {
            // 加载中状态
            isloading: false,
            // 搜索内容
            value: '',
            // 常用群组数据
            groupData: [],
            // 常用联系人数据
            topContactsData: [],
            // 新增层状态
            show: false,
            // 索引数组
            indexList: [],
            // 新增层内容
            actions: [
                {
                    name: '添加联系人',
                    id: 'addContact',
                }, {
                    name: '创建群组',
                    id: 'createGroup',
                },
            ],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 获取好友列表
        this.getFriends();
        // 调用原生获取群组数据
        this.callMobileNative_GetTeamsListInfo();
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 添加好友
        addUser() {
            this.show = true;
        },
        // 选择添加好友还是新建群组
        onSelect(item) {
            if (item.id === 'addContact') {
                // 新增联系人
                this.$router.isBack = 2;
                this.$router.push({ path: '/addContact' });
            } else if (item.id === 'createGroup') {
                // 新增群组
                this.$router.isBack = 2;
                this.$router.push({ path: '/newGroup' });
            }
            this.show = false;
        },
        // 获取好友列表
        getFriends() {
            this.isloading = true;
            this.$axios
                .get('/interfaceApi/message/MessageNetease/get_friends')
                .then(res => {
                    // 处理数据
                    const newData = this.$dataSorting(res, 'friend_name');
                    // 常用联系人数据赋值
                    this.topContactsData = newData.dataList;
                    // 索引数组赋值
                    this.indexList = newData.indexList;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 打开联系人信息页
        openContactInfo(id) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/contactInfo', query: { User_Id: id, isFriend: true } });
        },
        // 通过js函数通知原生，需要获取群组信息
        callMobileNative_GetTeamsListInfo() {
            this.$callMobile('JYTeamsNative', 'GetTeamsListInfo', '');
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            this.groupData = JSON.parse(chartGroupJson).teams;
        },
        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },
    },
};
</script>
<style lang="stylus">
.addressBook
    height 100%
    .noData
        width 100%
        height calc(100% - 44rpx)
        background url(./../../../assets/images/addressBook/no_address_book@2x.png) center no-repeat
        background-size 100%
    section
        height calc(100% - 44rpx)
        .list
            height calc(100% - 44rpx)
            overflow-y scroll
            -webkit-overflow-scrolling: touch;

            dl
                position relative
                &:nth-of-type(1)
                    dt
                        border-top 0
            dt,dd
                border-bottom 1px solid #F0F0F0
            dt
                line-height 44rpx
                font-size 16rpx
                color #333333
                padding 0 15rpx
                border-top 15rpx solid #F0F0F0
            dd
                .van-cell
                    // height 60rpx
                    padding 10rpx 15rpx
                    &:after
                        left 0
                    img
                        width 40rpx
                        height 40rpx
                        margin-right 10rpx
                    .info
                        width calc(100% - 50rpx)
                        p,span
                            width 100%
                            float left
                        p
                            font-size 18rpx
                            line-height 20rpx
                            color #333333
                            margin-bottom 8rpx
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        span
                            font-size 12rpx
                            line-height 14rpx
                            color #979EA7
                .van-index-anchor
                    font-size 12rpx
                    line-height 20rpx
                    background #F9F9F9
</style>